export default __webpack_public_path__ + "static/media/slack.2ac28a8d.svg";